import { observeHeaderHeight } from './utils.js';
// --------------------Quick Fixes----------------------//

function makeAccessibleButton($el, label) {
  $el
    .attr({
      tabindex: 0,
      role: 'button',
      'aria-label': label,
    })
    .on('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
}

function removeFocusCart() {
  const cartLink = $('.header .cartMenuLink');
  const href = (cartLink.attr('href') || '').trim();
  const isNavigable = href.startsWith('http');

  if (!isNavigable) {
    cartLink.attr('tabindex', '-1');
  }
}

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#262626" width="22" height="20"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;
  navToggle.html(bars);
  makeAccessibleButton(navToggle, 'open menu');
}

function searchBoxPlaceholder() {
  const searchInput = $('header .inputFieldTextbox');
  const searchButton = $('header .searchSubmitButton');
  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Type here...');
  searchButton.attr('tabindex', '-1');
  searchButton.attr('aria-label', 'submit search');
}

function modifySignup() {
  const signupWidget = $('.emailSignup');
  const input = signupWidget.find('.inputFieldTextbox');
  const submit = signupWidget.find('.emailSubmitButton');
  signupWidget.find('.emailSignupText').remove();
  input.val('');
  input.attr('placeholder', 'Email Address');
  submit.text('SUBSCRIBE');
  submit.attr('aria-label', 'Subscribe to newsletter');
}

// --------------------Lineup modifier----------------------//

function modifyFeatureLineup() {
  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

    if (icons.width() + buttons.width() > containerSize) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

$(document).ready(function () {
  const isHome = $('body').hasClass('homepage');
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  searchBoxPlaceholder();
  modifyFeatureLineup();
  makeAccessibleButton($('.close-mobile-menu'), 'close menu');
  removeFocusCart();
  observeHeaderHeight('.header');
  if (isHome) {
    return;
  } else {
    modifySignup();
  }
});
